define("checkout/components/payment/coupon", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/utils/fetch", "later/utils/focus", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _fetch, _focus, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _isCouponApplicableToPlan;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/fetch",0,"later/utils/focus",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @isVisible}}
    <div class="u--m__tb__md" {{did-insert this.resetState}}>
      <div class="u--block at-—checkout__addCoupon">
        <label>{{t "plans.checkout.coupon.title"}}</label>
        {{! Coupon Code (to be shown only for free to paid customers)}}
        <Shared::Ui::Button
          @class="{{if this.isCouponClicked 'u--text--light' 'tCH--text--highlight'}}  u--float--right qa--couponBtn"
          @isDisabled={{@isDisabled}}
          @onClick={{toggle-action "isCouponClicked" this}}
          @text={{if this.isCouponClicked (t "plans.checkout.coupon.hide") (t "plans.checkout.coupon.show")}}
          @variant="unstyled"
          data-test-id={{if this.isCouponClicked "hide" "show"}}
          type="button"
        />
      </div>
      {{#if this.isCouponClicked}}
        <form {{action (perform this.applyCoupon this.couponCode) on="submit"}}>
          <div class="o--inputAction--light tCH--formWrapper u--p__l qa--couponContainer">
            <Input
              @value={{this.couponCode}}
              class="couponCode o--inputAction__input qa--checkout_coupon_inputbox"
              data-test-id="input"
              disabled={{or this.applyCoupon.isRunning @isDisabled}}
              id="couponCode"
              placeholder={{t "plans.checkout.coupon.placeholder"}}
              {{autofocus}}
            />
            <Shared::Ui::Button
              @class="o--inputAction__icon--right tCH--text--highlight u--text--sm u--text--uppercase qa--checkout_coupon_apply_btn"
              @isDisabled={{or this.applyCoupon.isRunning @isDisabled}}
              @variant="unstyled"
              data-test-id="button"
              type="submit"
            >
              <span>{{t "plans.checkout.coupon.submit"}}</span>
            </Shared::Ui::Button>
          </div>
          <span
            class="couponMessage o--form__helpText {{if this.isError 'is--error'}} {{if this.isSuccess 'is--success'}}"
            data-test-id="message"
          >
            {{this.applyCoupon.last.value}}
          </span>
        </form>
      {{/if}}
    </div>
  {{/if}}
  */
  {
    "id": "6PeCtQlD",
    "block": "[[[41,[30,1],[[[1,\"  \"],[11,0],[24,0,\"u--m__tb__md\"],[4,[38,1],[[30,0,[\"resetState\"]]],null],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--block at-—checkout__addCoupon\"],[12],[1,\"\\n      \"],[10,\"label\"],[12],[1,[28,[35,2],[\"plans.checkout.coupon.title\"],null]],[13],[1,\"\\n\"],[1,\"      \"],[8,[39,3],[[16,\"data-test-id\",[52,[30,0,[\"isCouponClicked\"]],\"hide\",\"show\"]],[24,4,\"button\"]],[[\"@class\",\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[29,[[52,[30,0,[\"isCouponClicked\"]],\"u--text--light\",\"tCH--text--highlight\"],\"  u--float--right qa--couponBtn\"]],[30,2],[28,[37,4],[\"isCouponClicked\",[30,0]],null],[52,[30,0,[\"isCouponClicked\"]],[28,[37,2],[\"plans.checkout.coupon.hide\"],null],[28,[37,2],[\"plans.checkout.coupon.show\"],null]],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"isCouponClicked\"]],[[[1,\"      \"],[11,\"form\"],[4,[38,5],[[30,0],[28,[37,6],[[30,0,[\"applyCoupon\"]],[30,0,[\"couponCode\"]]],null]],[[\"on\"],[\"submit\"]]],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--inputAction--light tCH--formWrapper u--p__l qa--couponContainer\"],[12],[1,\"\\n          \"],[8,[39,7],[[24,0,\"couponCode o--inputAction__input qa--checkout_coupon_inputbox\"],[24,\"data-test-id\",\"input\"],[16,\"disabled\",[28,[37,8],[[30,0,[\"applyCoupon\",\"isRunning\"]],[30,2]],null]],[24,1,\"couponCode\"],[16,\"placeholder\",[28,[37,2],[\"plans.checkout.coupon.placeholder\"],null]],[4,[38,9],null,null]],[[\"@value\"],[[30,0,[\"couponCode\"]]]],null],[1,\"\\n          \"],[8,[39,3],[[24,\"data-test-id\",\"button\"],[24,4,\"submit\"]],[[\"@class\",\"@isDisabled\",\"@variant\"],[\"o--inputAction__icon--right tCH--text--highlight u--text--sm u--text--uppercase qa--checkout_coupon_apply_btn\",[28,[37,8],[[30,0,[\"applyCoupon\",\"isRunning\"]],[30,2]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n            \"],[10,1],[12],[1,[28,[35,2],[\"plans.checkout.coupon.submit\"],null]],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[15,0,[29,[\"couponMessage o--form__helpText \",[52,[30,0,[\"isError\"]],\"is--error\"],\" \",[52,[30,0,[\"isSuccess\"]],\"is--success\"]]]],[14,\"data-test-id\",\"message\"],[12],[1,\"\\n          \"],[1,[30,0,[\"applyCoupon\",\"last\",\"value\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"@isVisible\",\"@isDisabled\"],false,[\"if\",\"did-insert\",\"t\",\"shared/ui/button\",\"toggle-action\",\"action\",\"perform\",\"input\",\"or\",\"autofocus\"]]",
    "moduleName": "checkout/components/payment/coupon.hbs",
    "isStrictMode": false
  });
  let CouponComponent = _exports.default = (_class = (_isCouponApplicableToPlan = /*#__PURE__*/new WeakSet(), class CouponComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _isCouponApplicableToPlan);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "isCouponClicked", _descriptor2, this);
      _initializerDefineProperty(this, "isSuccess", _descriptor3, this);
      _initializerDefineProperty(this, "isError", _descriptor4, this);
      _initializerDefineProperty(this, "couponCode", _descriptor5, this);
      _defineProperty(this, "applyCoupon", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (couponCode) {
          this.isSuccess = false;
          this.isError = false;
          try {
            const {
              coupon
            } = yield (0, _fetch.fetch)(`/api/v2/stripe_coupon/${couponCode}`);
            if (!_classPrivateMethodGet(this, _isCouponApplicableToPlan, _isCouponApplicableToPlan2).call(this, coupon)) {
              this.isError = true;
              return this.intl.t('plans.checkout.coupon.error_invalid_plan');
            }
            this.args.onCoupon(coupon);
            this.isSuccess = true;
            (0, _focus.default)('#couponCode');
            return this.intl.t('plans.checkout.coupon.success');
          } catch ({
            code,
            status
          }) {
            this.isError = true;
            (0, _focus.default)('#couponCode');
            if (status === 404 || code === 404) {
              return this.intl.t('plans.checkout.coupon.error_not_found');
            }
            return this.intl.t('plans.checkout.coupon.error_generic');
          }
        }
      }), null, "applyCoupon", "drop"));
    }
    /**
     * Reset State when component is visible to prevent showing old applied message
     * and entered coupon that is not currently being applied
     */
    resetState() {
      this.isCouponClicked = false;
      this.isSuccess = false;
      this.isError = false;
      this.couponCode = null;
      this.applyCoupon.cancelAll({
        resetState: true
      });
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isCouponClicked", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isSuccess", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "couponCode", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "resetState", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetState"), _class.prototype)), _class);
  function _isCouponApplicableToPlan2(coupon) {
    return !coupon.applies_to || coupon.applies_to.products.includes(this.args.selectedSubscriptionPlan.stripeProductId);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CouponComponent);
});